import {
    Component,
    OnInit
} from "@angular/core";
import * as fromRootStore from "../../../reducers";
import * as fromCommonStore from "../../../store";
import * as _ from "lodash";
import { Store } from "@ngrx/store";
import * as _moment from 'moment';
import { CacService } from "../../../services/cac.service";
import { FormControl } from "@angular/forms";
import { CommonService } from "../../../services";
import * as moment from 'moment';

@Component({
    selector: "branchwise_cac_month",
    templateUrl: "./branchwiseCACMonth.component.html"
})
export class branchwiseCACMonthComponent implements OnInit {
    loading: boolean;
    dataList: any;
    column: any;
    branchList: any;
    filterData: any;
    branchOption: any;
    branchCtrl = new FormControl();
    monthCtrl = new FormControl();
    errorMessage: any;

    constructor(
        public cacService: CacService,
        public store: Store<fromRootStore.State>,
        public commonService: CommonService,
    ) {
        this.branchList = [];
        //  FILTER PROPERTIES
        this.filterData = {
            branch: "",
            branch_id: "",
            fromYear: this.getPreviousYear(),
            toYear: this.getCurYear()
        };
    }


    ngOnInit() {
        this.applyFilter();
        // BRANCH LIST PROPERTIES
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            this.branchList.push({ 'branch_id': -1, 'branch_name': "All" });
            res.data.map(branchObj => {
                if(branchObj.is_crm_branch == 'Yes' && branchObj.branch_name != 'HEAD OFFICE')
                  this.branchList.push(branchObj);
              });
        });

        this.branchOption = this.branchCtrl.valueChanges
            .startWith("")
            .map(name => (name ? this.filterBranch(name) : this.branchList.slice()));
        this.filterData.branch_id = -1;
    }

    // BRANCH LIST PROPERTIES
    displayBranch(item_id: number) {
        if (item_id && this.branchList.length > 0) {
            let fitem: any = _.find(this.branchList, { branch_id: item_id }),
                ref_name = fitem.branch_name ? fitem.branch_name : "";
            this.filterData.branch = fitem;
            return ref_name;
        }
        return "";
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(ha =>
            new RegExp(name, "gi").test(ha.branch_name)
        );
    }
    // --------------------------------

    applyFilter() {
        this.getReport(this.filterData)
    }


    getReport(data) {
        this.loading = true;
        let param = {
            branch_id: (this.filterData.branch_id) ? this.filterData.branch_id : -1,
            fromFinYear: moment(this.filterData.fromYear).format('YYYY'),
            toFinYear: moment(this.filterData.toYear).format('YYYY')
        }
        this.cacService.getBranchCACPercentageReport(param).then((res: any) => {
            this.column = res.column;
            this.dataList = res.data;
            this.loading = false;
            if (this.dataList.length == 0) {
                this.errorMessage = "There no data Found!!!!";
            } else {
                this.errorMessage = "";
            }
        });
    }

    onClickExcelBtn() {
        let that = this,
            data = {
                columns: JSON.stringify(this.column),
                data: JSON.stringify(this.dataList),
                title: "Branchwise CAC Monthly Report"
            };
        this.commonService
            .exportExcelMulti(data)
            .then(function (res: any) {
                if (res['_body']) {
                    var headers = res['headers']["_headers"],
                        ctype = headers.get('content-type')[0],
                        cdispos = headers.get('content-disposition')[0],
                        filename = cdispos.replace(/attachment;filename=|"/gi, ''),
                        blob = new Blob([res['_body']], {
                            type: ctype
                        }),
                        link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    //that.toasterService.pop(toast);
                }
            });
    }

    maxDate() {
        let curDate = new Date();
        let date = new Date(+this.getYear(curDate), 0, 1);
        if (this.filterData.toYear) {
            date = new Date(+this.getYear(this.filterData.toYear) - 1, 0, 1);
        }
        return date;
    }

    minDate() {
        let curDate = new Date();
        let date = new Date(+this.getYear(curDate), 0, 1);
        if (this.filterData.fromYear) {
            date = new Date(+this.getYear(this.filterData.fromYear) + 1, 0, 1);
        }
        return date;
    }

    getYear(date) {
        var dt = moment(date).format('YYYY');
        return dt;
    }

    getPreviousYear() {
        let curDate = new Date(),
            year = curDate.getFullYear() - 1,
            preYear = new Date(year, 0, 1);
        return preYear;
    }

    getCurYear() {
        let curDate = new Date(),
            year = curDate.getFullYear(),
            curYear = new Date(year, 0, 1);
        return curYear;
    }

}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/management/branchwise_cac_month/branchwiseCACMonth.component.ts